import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NavigationModule } from 'src/core-lib/navigation/navigation.module';
import { CalendlyComponent } from 'src/externals/calendly/calendly.component';
import { MediaModule } from 'src/layout/media/media.module';
import { CalendlyElementComponent } from './calendly-element.component';



@NgModule({
    declarations: [CalendlyElementComponent],
    imports: [
        CommonModule,
        MediaModule,
        NavigationModule,
        CalendlyComponent,
    ]
})
export class CalendlyElementModule {
    static components = { 'calendlyElement': CalendlyElementComponent };
}
